import * as ReactDOM from 'react-dom/client';
import { PlusOutlined } from '@ant-design/icons';
import { green, red, yellow, blue } from '@ant-design/colors';
import cookie from 'react-cookies';
import OSS from 'ali-oss';
import CNF from './Config';
import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
import { format } from 'd3-format'
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';

import {
    ConfigProvider,
    Space,
    Button,
    Dropdown,
    message,
} from 'antd';
import {
    DownOutlined,
    EditOutlined,
    DeleteOutlined,
    LockOutlined,
    UnlockOutlined,
} from '@ant-design/icons';

// 导出页面为PDF格式
import html2canvas from "html2canvas";
import JSPDF from "jspdf";

import IPModal from '../components/IPModal';
import DefaultImagePng from '../images/default-image.png';

/**
 * 将一些功能进行封装，可作为模块进行引入
 * 变量使用小驼峰命名，方法使用大驼峰命名
 * 模块分为项目通用和项目专用
 */

/********************项目通用*******************/
/**
 * 国际化语言
 */
export const locale = CNF.locale === 'zhCN' ? zhCN : enUS;

function getWinWidth() {
    var winWidth = 0;
    // 获取窗口宽度
    if (window.innerWidth) {
        winWidth = window.innerWidth;
    } else if ((document.body) && (document.body.clientWidth)) {
        winWidth = document.body.clientWidth;
    }
    return winWidth;
}
/***
 * 浏览器宽度
 */
export const winWidth = getWinWidth();

function getWinHeight() {
    var winHeight = 0;
    //  获取窗口高度
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }
    return winHeight;
}
/***
 * 浏览器高度
 */
export const winHeight = getWinHeight();

/**
 * 是否大于配置文件设定的屏幕宽度，用于使用字段显示宽度
 */
export const isGTscreenWidth = winWidth > CNF.screenWidth ? true : false;

function getOS() {
    var sUserAgent = navigator.userAgent;
    var isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows');
    var isMac = (navigator.platform === 'Mac68K') || (navigator.platform === 'MacPPC') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel');
    if (isMac) return 'Mac';
    var isUnix = (navigator.platform === 'X11') && !isWin && !isMac;
    if (isUnix) return 'Unix';
    var isLinux = (String(navigator.platform).indexOf('Linux') > -1);
    if (isLinux) return 'Linux';
    if (isWin) {
        var isWin2K = sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1;
        if (isWin2K) return 'Win2000';
        var isWinXP = sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1;
        if (isWinXP) return 'WinXP';
        var isWin2003 = sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1;
        if (isWin2003) return 'Win2003';
        var isWinVista = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1;
        if (isWinVista) return 'WinVista';
        var isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1;
        if (isWin7) return 'Win7';
        var isWin10 = sUserAgent.indexOf('Windows NT 10') > -1 || sUserAgent.indexOf('Windows 10') > -1;
        if (isWin10) return 'Win10';
    }
    return 'other';
}

/***
 * 操作系统信息
 */
export const os = getOS();

function generateUUID() {
    return uuidv4();
}
/**
 * 生成UUID
 */
export const uuid = generateUUID();

/**
 * 当前登录用户名
 */
export const username = cookie.load(CNF.cookies.keyId) ? cookie.load(CNF.cookies.keyId) : '';

/**
 * 必填项标志（Required field flag）用rff简写
 */
export const rff = <span style={{ color: 'red' }}>*</span>;

/**
 * 默认图片数据
 */
export const defaultImage = DefaultImagePng

/**
 * 主要用于通用弹框
  */
export const rootReactDom = ReactDOM.createRoot(document.createElement('div'));

/**
 * 表格中金额类列宽Tag标签宽度所占百分比
 */
export const amountTagWidthPercent = winWidth > CNF.screenWidth ? '90%' : '100%';

/**
 * 上传图片按钮
 */
export const uploadImageButton = (
    <button
        style={{
            border: 0,
            background: 'none',
            cursor: 'pointer',
        }}
        type='button'
    >
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>上传图片</div>
    </button>
);

/**
 * 将图片转换成base64格式
 * @param {*} img 
 * @param {*} callback 
 */
export function GetBase64(img, callback) {
    // 创建一个FileReader对象用于读取图片数据
    const reader = new FileReader();

    // 当读取完成时触发load事件，调用回调函数并传入读取的结果
    reader.addEventListener('load', () => callback(reader.result));

    // 开始读取图片数据，将其转换为DataURL格式
    reader.readAsDataURL(img);
}

/**
 * 连接资源参数
 * @param {*} obj 
 * @returns 
 */
export function UjoinParams(obj) {
    var params = '?'
    for (var key in obj) {
        params += key + '=' + obj[key] + '&'
    }
    return params.substr(0, params.length - 1)
}

/**
 * 日期格式化
 * @param {*} fmt 
 * @param {*} date 
 * @returns 
 */
export function UdateFormat(fmt, date) {
    let ret;
    const opt = {
        'Y+': date.getFullYear().toString(),        // 年
        'm+': (date.getMonth() + 1).toString(),     // 月
        'd+': date.getDate().toString(),            // 日
        'H+': date.getHours().toString(),           // 时
        'M+': date.getMinutes().toString(),         // 分
        'S+': date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        };
    };
    return fmt;
}


/**
 * 金额格式化，默认千分位用逗号隔开，保留两位有效数字
 */
export const AmountFormat = format(',.2f');

/**
 * 数字格式化，默认千分位用逗号隔开
 */
export const NumberFormat = format(',');

/***
 * 获取url中'?'符后的字符串并正则匹配
 * @param {*} obj 
 * @returns 
 */
export function GetQueryString(name) {
    var reg = new RegExp('(^|[?&])' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.match(reg); //获取url中'?'符后的字符串并正则匹配
    var context = '';
    if (r != null)
        context = decodeURIComponent(r[2]);
    reg = null;
    r = null;
    return context === null || context === '' || context === 'undefined' ? '' : context;
}

/**
 * Token相关信息存入Cookie
 * @param {*} tokenArr 
 */
export function SaveCookies(tokenArr) {
    cookie.save(CNF.cookies.keyId, tokenArr.info.username,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire });
    cookie.save(CNF.cookies.keyUid, tokenArr.info.uid,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire });
    cookie.save(CNF.cookies.keyDisplayname, tokenArr.info.displayname,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: CNF.cookies.keyExpire });
    cookie.save(CNF.cookies.keyToken, tokenArr.access_token,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath, expire: tokenArr.expires_in });
}

/**
 * 删除cookie，并重定向到登录界面
 */
export function DeleteCookies() {
    cookie.remove(CNF.cookies.keyId,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyUid,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyDisplayname,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyToken,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyAvatarUrl,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyThemeColor,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    cookie.remove(CNF.cookies.keyIsDisplayTableBorder,
        { domain: CNF.cookies.keyDomain, path: CNF.cookies.keyPath });
    window.location.href = CNF.loginUrl;
}

/**
 * 获取随机字符串
 * @param {*} length 
 * @returns 
 */
export function GetRandomString(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    const array = new Uint32Array(length); // 创建一个足够大的Uint32Array数组
    window.crypto.getRandomValues(array); // 使用crypto.getRandomValues填充数组
    for (let i = 0; i < length; i++) {
        result += characters.charAt(array[i] % charactersLength);
    }
    return result;
}

/**
 * 添加请求头
 * @returns 
 */
export function AddRequestHeaders(ct = "application/json") {
    let headers = {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + cookie.load(CNF.cookies.keyToken),
    }
    if (ct) {
        headers['Content-Type'] = ct;
    }
    return headers;
}

/***
 * elementName: 需要输出PDF的页面id
 * htmlTitle: 页面标题
 * currentTime：创建时间
 */
export function Html2pdf(elementName, htmlTitle, currentTime, hasImage = false) {
    const a4w = 190;    //  A4大小，210mm x 297mm，四边各保留20mm的边距
    const a4h = 237;
    var element = document.getElementById(elementName);
    var tableDom = document.getElementById('table-id');
    var tableHeight = a4h;
    if (tableDom) {
        tableHeight = tableDom.getBoundingClientRect().height / 3.78;   //  转换成mm
    }
    var emptyDiv = null;
    //  判断table的高度是否小于a4h，如果小于a4h，则插入一个div填充table，使其刚好等于a4h
    if (tableHeight < a4h && hasImage) {
        emptyDiv = document.createElement('div');
        emptyDiv.style.width = '100%';
        emptyDiv.style.height = `${a4h - tableHeight + 20}mm`;
        tableDom.insertAdjacentElement('afterend', emptyDiv);
    }
    html2canvas(element, {
        logging: false,
        useCORS: true,
        scale: 2,
    }).then(function (canvas) {
        var pdf = new JSPDF('p', 'mm', 'a4'); // A4纸，纵向
        var ctx = canvas.getContext('2d');
        var imgHeight = Math.floor(a4h * canvas.width / a4w); // 按A4显示比例换算一页图像的像素高度

        var renderedHeight = 0;
        while (renderedHeight < canvas.height) {
            var page = document.createElement('canvas');
            page.width = canvas.width;
            page.height = Math.min(imgHeight, canvas.height - renderedHeight); // 可能内容不足一页

            // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
            page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
            pdf.addImage(page.toDataURL('image/jpeg', 3.0), 'JPEG', 10, 10, a4w, Math.min(a4h, a4w * page.height / page.width)) // 添加图像到页面，保留10mm边距

            renderedHeight += imgHeight
            if (renderedHeight < canvas.height) {
                pdf.addPage(); // 如果后面还有内容，添加一个空页
            }
        }
        pdf.save(htmlTitle + currentTime + '.pdf');
        if (emptyDiv) {
            emptyDiv.remove();  //  删除空白节点
        }
    })
}

export function Html2pdf2(elementName, htmlTitle, currentTime) {
    //  A4纸张的宽度和高度
    const A4_WIDTH = 592.28;
    const A4_HEIGHT = 841.89;
    var printDom = document.getElementById(elementName);
    //  计算页面的高度
    const pageHeight = (printDom.getBoundingClientRect().width / A4_WIDTH) * A4_HEIGHT;

    //  获取DOM节点，是可能会被截断的DOM节点
    const wholeNodes = document.querySelectorAll(".whole-node");
    for (let i = 0; i < wholeNodes.length; i++) {
        //  计算分页的页数
        const bottomPageNum = Math.ceil((wholeNodes[i].offsetTop + wholeNodes[i].offsetHeight) / pageHeight);
        //  这个条件判断是元素i距离上方或上层控件的位置+元素i本身的高度小于A4纸的高度，
        //  并且下一个元素距离上方或上层控件的位置+下一个元素本身的高度大于A4纸的高度意味着当前页面的内容则在中间插入一个空白块，
        //  空白的高度计算为：A4纸的高度减去减去元素i的offsetTop+offsetHeight需要分页处理。
        if (
            wholeNodes[i].offsetTop + wholeNodes[i].offsetHeight < pageHeight * bottomPageNum && wholeNodes[i + 1] && wholeNodes[i + 1].offsetTop + wholeNodes[i + 1].offsetHeight > pageHeight * bottomPageNum
        ) {
            const divParent = wholeNodes[i].parentNode;
            const newBlock = document.createElement("div");
            newBlock.className = "emptyDiv";
            newBlock.style.background = "#fff";
            //  计算空白区域的高度，以便正确地填充在当前页面和下一页面之间。_H 是当前节点到底部的距离，32px 是一个额外的空间，作为安全边距或分页缓冲
            const _H = bottomPageNum * pageHeight - wholeNodes[i].offsetTop - wholeNodes[i].offsetHeight;
            newBlock.style.height = `${_H + 32}px`;
            const next = wholeNodes[i].nextSibling;
            if (next) {
                divParent.insertBefore(newBlock, wholeNodes[i]);
            } else {
                divParent.appendChild(newBlock);
            }
        }
    }
    //  使用 html2canvas 库将 printDom 元素的内容渲染成一个图像（canvas）
    html2canvas(printDom, {
        useCORS: true,
        scale: 1,
    }).then(function (canvas) {
        //  使用 html2canvas 再次渲染 printDom，并在渲染完成后执行 then() 回调，删除刚刚创建的空白占位元素。
        html2canvas(printDom, {
            height: printDom.getBoundingClientRect().height,
            width: printDom.getBoundingClientRect().width,
            allowTaint: true
        }).then(() => {
            const emptyDivs = document.querySelectorAll(".emptyDiv");
            for (let i = 0; i < emptyDivs.length; i++) {
                emptyDivs[i].parentNode.removeChild(emptyDivs[i]);
            }
        });

        //  获取渲染的 canvas 宽度和高度，并将其乘以 2，
        //  因为 canvas 的渲染通常是基于设备像素比例进行缩放的，我们需要还原为实际的物理像素。
        const contentWidth = parseInt(canvas.style.width) * 2;
        const contentHeight = parseInt(canvas.style.height) * 2;
        const imgWidth = 592.28;
        const imgHeight = (592.28 / contentWidth) * contentHeight;
        const pageData = canvas.toDataURL("image/jpeg", 1.0);
        const PDF = new JSPDF("p", "pt", "a4");
        let leftHeight = contentHeight;
        //  初始化 leftHeight 为内容的总高度，position 用于控制每一页图像的位置。
        let position = 0;

        //  判断 leftHeight 是否小于等于页面的高度 pageHeight。如果小于等于，直接将图像添加到 PDF 中。
        //  如果大于，则分多页添加图像，每页添加 841.89 的高度，直到所有内容都被添加到 PDF 中。position 用于控制图像在每页中的垂直位置。
        if (leftHeight <= pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
            while (leftHeight > 0) {
                PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
                leftHeight -= (contentWidth / 592.28) * 841.89;
                position -= 841.89;
                if (leftHeight > 0) {
                    PDF.addPage();
                }
            }
        }
        PDF.save(htmlTitle + currentTime + '.pdf')
    });
}

/**
 * base64转为ArrayBuffer
 * @param {*} dataUrl 
 * @returns 
 */
export function Base64DataUrlToArrayBuffer(dataUrl) {
    const base64Regex = /^data:image\/(png|jpg|jpeg);base64,/;
    if (!base64Regex.test(dataUrl)) {
        return false;
    }
    const stringBase64 = dataUrl.replace(base64Regex, '');
    let binaryString;
    if (typeof window !== 'undefined') {
        binaryString = window.atob(stringBase64);
    } else {
        binaryString = new Buffer(stringBase64, 'base64').toString('binary');
    }
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes.buffer;
}

/**
 * 获取当前时间
 * YYYY-MM-dd HH:mm:ss
 * @returns 
 */
export function CurrentTime() {
    var date = new Date();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var strHours = date.getHours();
    var strtMinutes = date.getMinutes();
    var strtSeconds = date.getSeconds();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    if (strHours >= 0 && strHours <= 9) {
        strHours = '0' + strHours;
    }
    if (strtMinutes >= 0 && strtMinutes <= 9) {
        strtMinutes = '0' + strtMinutes;
    }
    if (strtSeconds >= 0 && strtSeconds <= 9) {
        strtSeconds = '0' + strtSeconds;
    }
    var currentTime = date.getFullYear() + '-' + month + '-' + strDate + ' ' + strHours + ':' + strtMinutes + ':' + strtSeconds;
    return currentTime;
}

/**
 * 获取当前日期
 * YYYY-MM-dd
 * @returns 
 */
export function CurrentDate() {
    var date = new Date();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    var currentDate = date.getFullYear() + '-' + month + '-' + strDate;
    return currentDate;
}

/**
 * 获取当前月
 * YYYY-MM
 * @returns 
 */
export function CurrentMonth() {
    var date = new Date();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    var currentMonth = date.getFullYear() + '-' + month;
    return currentMonth;
}

/**
 * 获取上一月
 * YYYY-MM
 * @returns 
 */
export function LastMonth() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth();
    if (month < 1) {
        month = 12;
        year -= 1;
    }
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    var lastMonth = year + '-' + month;
    return lastMonth;
}

/**
 * 显示提示框信息信息
 * @param {*} key 
 * @param {*} title 
 * @param {*} action 
 * @param {*} modulename 
 * @param {*} isRefresh 
 * @param {*} uri 
 */
export const ShowIPModal = (key, title, action, modulename, setRefresh, uri, getPolicys = null) => {
    rootReactDom.render(
        <IPModal
            open={true}
            setRefresh={setRefresh}
            action={action}
            key={key}
            modulename={modulename}
            uri={uri}
            getPolicys={getPolicys}
            title={title}
        />
    );
}

/**
 * 获取按钮操作名称
 * @param {*} btnLists 权限列表
 * @param {*} modulename_ptn 模块权限
 * @param {*} record 当前行数据
 * @param {*} operation 操作
 * @returns 
 */
export function GetButtonActionName(btnLists, modulename_ptn, record, operation) {
    // 模块权限列表
    let mBtnLists = typeof btnLists === 'string' ? btnLists.split('|').filter(item => item.startsWith(modulename_ptn)) : [];
    return <Space size={CNF.searchMarginLeft}>
        {/* 修改 */}
        {mBtnLists.indexOf(modulename_ptn + '_update') > 0 ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.UPDATE, record) }}>{CNF.actionName.UPDATE}</Button> : ''}
        {/* 禁用 */}
        {mBtnLists.indexOf(modulename_ptn + '_disable') > 0 &&
            record.status === CNF.status[0].value ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.DISABLE, record) }}>{CNF.actionName.DISABLE}</Button> : ''}
        {/* 激活 */}
        {mBtnLists.indexOf(modulename_ptn + '_active') > 0 &&
            record.status === CNF.status[1].value ? <Button size='small' color='primary' variant='outlined' onClick={() => { operation(CNF.actionName.ACTIVE, record) }}>{CNF.actionName.ACTIVE}</Button> : ''}
        {/* 删除 */}
        {mBtnLists.indexOf(modulename_ptn + '_delete') > 0 ? <Button size='small' color='primary' variant='solid' onClick={() => { operation(CNF.actionName.DELETE, record) }}>{CNF.actionName.DELETE}</Button> : ''}
    </Space>
}

/**
 * 获取基础操作名称
 * @param {*} btnLists 权限列表
 * @param {*} modulename_ptn 模块权限
 * @param {*} record 当前行数据
 * @param {*} operation 操作
 * @returns 
 */
export function GetDropdownActionName(btnLists, modulename_ptn, record, operation) {
    // 模块权限列表
    let mBtnLists = typeof btnLists === 'string' ? btnLists.split('|').filter(item => item.startsWith(modulename_ptn)) : [];
    let items = [];
    // 修改
    if (mBtnLists.indexOf(modulename_ptn + '_update') > 0) {
        items.push({ key: '2', label: (<Button icon={<EditOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.UPDATE, record) }}>{CNF.actionName.UPDATE}</Button>) })
    }
    // 禁用
    if (mBtnLists.indexOf(modulename_ptn + '_disable') >= 0 &&
        record.status.toString() === CNF.status[0].value.toString()) {
        items.push({ key: '11', label: (<Button icon={<LockOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.DISABLE, record) }}>{CNF.actionName.DISABLE}</Button>) })
    }
    // 激活
    if (mBtnLists.indexOf(modulename_ptn + '_active') >= 0 &&
        record.status.toString() === CNF.status[1].value.toString()) {
        items.push({ key: '12', label: (<Button icon={<UnlockOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.ACTIVE, record) }}>{CNF.actionName.ACTIVE}</Button>) })
    }
    // 删除
    if (mBtnLists.indexOf(modulename_ptn + '_delete') >= 0) {
        items.push({ key: '13', label: (<Button icon={<DeleteOutlined />} color='primary' variant='link' onClick={() => { operation(CNF.actionName.DELETE, record) }}>{CNF.actionName.DELETE}</Button>) })
    }
    return <ConfigProvider
        theme={{
            components: {
                Dropdown: {
                    paddingBlock: 0,
                },
                Button: {
                    paddingInline: 0,
                }
            },
        }}
    >
        <Dropdown menu={{ items, }}>
            <Button color='primary' variant='link' style={{ padding: 0, height: 10, margin: 0 }}>
                操作
                <DownOutlined />
            </Button>
        </Dropdown>
    </ConfigProvider>
}

/**
 * 根据标签ID，将滚动条移到最下面
 * @param {*} id 
 */
export function ToScrollBottom(id) {
    let d = document.getElementById(id);
    d.scrollTop = d.scrollHeight;
}

/**
 * 连接阿里云OSS实体
 * @param {*} token
 * @returns 
 */
export const AliyunOSSclient = (token) => {
    let params = { 'oss': 'GetObject' }
    return new OSS({
        region: token.oss_region,
        accessKeyId: token.Credentials.AccessKeyId,
        accessKeySecret: token.Credentials.AccessKeySecret,
        stsToken: token.Credentials.SecurityToken,
        authorizationV4: true,
        refreshSTSToken: async () => {
            // 向您搭建的STS服务获取临时访问凭证。
            const info = await fetch(CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params), {
                method: 'GET',
                headers: AddRequestHeaders(),
            });
            return {
                accessKeyId: info.dat.Credentials.accessKeyId,
                accessKeySecret: info.dat.Credentials.accessKeySecret,
                stsToken: info.dat.Credentials.stsToken,
            };
        },
        refreshSTSTokenInterval: 3500000, // 刷新临时访问凭证的时间间隔，单位为毫秒。
        internal: process.env.REACT_APP_OSS_INTERNAL === 'true' ? true : false,
        secure: true,
        bucket: token.bucket_name
    });
}

/**
 * 从阿里云删除
 * @param {*} file 
 * @returns 
 */
export const AliyunOSSDelete = (file) => {
    var params = {
        'oss': 'DeleteObject'
    }
    $.ajax({
        url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
        headers: AddRequestHeaders(),
        type: 'GET', success: function (data) {
            if (data.res === 0) {
                const token = data.dat;
                try {
                    AliyunOSSclient(token).delete(file.path);
                } catch (e) {
                    // console.log(e);
                }
            } else {
                message.error(data.msg, CNF.messageDuration);
            }
        }
    });
    return false
}

/**
 * 从阿里云下载
 * @param {*} file
 */
export const AliyunOSSDownload = (file) => {
    var params = {
        'oss': 'GetObject'
    }
    $.ajax({
        url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
        headers: AddRequestHeaders(),
        type: 'GET', success: function (data) {
            if (data.res === 0) {
                const token = data.dat;
                try {
                    let result = AliyunOSSclient(token).signatureUrl(file.path, {
                        expires: 3600,
                        response: {
                            'content-disposition': 'attachment; filename="' + file.name + '"'
                        }
                    });
                    return result;
                } catch (e) {
                    console.log(e);
                }
            } else {
                message.error(data.msg, 1);
            }
        }
    });
}


/**
 * 获取列表中某个字段的最大宽度值
 * @param {*} arr 列表数组
 * @param {*} key 要对比的键
 * @param {*} minWidth 最新宽度
 * @returns 
 */
export const GetArrSpanMaxWidth = (arr, key, minWidth) => {
    if (arr.length < 1 || !key) {
        return minWidth;
    }
    let item = arr.reduce((max, cur) => {
        return max[key].length > cur[key].length ? max : cur;
    });
    let span = document.createElement('span');
    span.style.width = 'auto';
    span.innerHTML = item[key];
    document.body.appendChild(span);
    let maxWidth = span.offsetWidth;
    document.body.removeChild(span);
    return maxWidth + 30 > minWidth ? maxWidth + 30 : minWidth;
};
/********************项目特有*******************/
const GenPresets = (presets) => {
    let data = Object.entries(presets);
    for (let i = 0; i < data.length; i++) {
        switch (data[i][0]) {
            case 'red':
                data[i][0] = '红色'
                break;
            case 'green':
                data[i][0] = '绿色'
                break;
            case 'blue':
                data[i][0] = '蓝色'
                break;
            case 'yellow':
                data[i][0] = '黄色'
                break;
            default:
            //
        }
    }
    return data.map(([label, colors]) => ({
        label,
        colors,
    }));
}

/**
 * 预设颜色
 * @returns 
 */
export const presets = GenPresets({
    red,
    green,
    blue,
    yellow,
});